import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { EnvironmentTypeEnum } from 'environments/environment-type.enum';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.environmentType === EnvironmentTypeEnum.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);
